const autocompleteMaintenanceModalFilter = {
  sites: 'Sites',
  equipments: 'Tipo de Equipamento',
  place: 'Local',
  status: 'Status Manutenções',
  createdAt: 'Criada Em',
  sendToMaintenanceDate: 'Data de Envio',
  returnFromMaintenanceDate: 'Data de Retorno',
  warranty: 'Prazo de Garantia',
  expiration: 'Prazo de Validade',
};

export default autocompleteMaintenanceModalFilter;
